// extracted by css-extract-rspack-plugin
export default {"root":"root-ewmtZS"};